import Title from "../../../components/atoms/Title";
import SelectBox from "../../../components/atoms/SelectBox";
import Loading from "../../../components/atoms/Loading";
import AreaChart from "../../../components/transactionPage/AreaChart";
import React from "react";
import {useTransactionContext} from "../TransactionContext";

const TransactionChart = () => {

    const {
        handleUpdateTransactionData,
        listState,
        transactionChartData
    } = useTransactionContext();

    const chartTypeOptions = [
        {value: "تعداد تراکنش", label: "تعداد تراکنش"},
        {value: "قیمت تراکنش", label: "قیمت تراکنش"},

    ];


    return (
        <div
            className="mr-7.5px ml-7.5px  bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px "
            dir="rtl">
            <div className="flex flex-row justify-between items-center h-10 ">
                <Title text="نمودار تراکـنش‌ها"/>
                <div className="flex flex-row gap-3.6">
                    <SelectBox
                        selected="تعداد تراکنش"
                        wbox={"123px"}
                        onChange={(event) => handleUpdateTransactionData("selectedType", event[0].value)}
                        options={chartTypeOptions}
                    />
                    <SelectBox
                        wbox={"141px"}
                        selected="بر اساس ماه جاری"
                        option4="بر اساس ماه جاری"
                        option1="3 ماه "
                        option2="6 ماه "
                        option3="12 ماه "
                        val4="1"
                        val1="3"
                        val2="6"
                        val3="12"
                        onChange={(event) => handleUpdateTransactionData("selectedTime", event[0].value)}

                    />
                </div>
            </div>
            {listState.loading ? (
                <>
                    <Loading height={"h-36v"}/>
                </>
            ) : (
                <AreaChart data={transactionChartData}/>
            )}
        </div>
    )
}
export default TransactionChart